var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 1.5H3.41C2.35514 1.5 1.5 2.35514 1.5 3.41V15.82C1.5 16.8749 2.35514 17.73 3.41 17.73H20.59C21.6449 17.73 22.5 16.8749 22.5 15.82V3.41C22.5 2.35514 21.6449 1.5 20.59 1.5Z",
    stroke: "#020202",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8201 22.5H8.18005L9.14005 17.73H14.8601L15.8201 22.5Z",
    stroke: "#020202",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31995 22.5H18.6799",
    stroke: "#020202",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.8099C12.5247 15.8099 12.95 15.3846 12.95 14.8599C12.95 14.3352 12.5247 13.9099 12 13.9099C11.4754 13.9099 11.05 14.3352 11.05 14.8599C11.05 15.3846 11.4754 15.8099 12 15.8099Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.67a740af4e1a9938ba0daa1db78b312f.svg";
export { ForwardRef as ReactComponent };